import webinarlogo from "../assets/images/webinarlogo.png";

export const NEWS_AND_EVENTS = [
  // {
  //   date: "September 8-10, 2025",
  //   img: finovate,
  //   newsAndEventsText: "FinovateFall 2025",
  //   websiteUrl: "https://www.inferiq.ai/conference/2025/finovatefall/",
  // },
  {
    date: "March 30, 2023",
    img: webinarlogo,
    newsAndEventsText: "Webinar: Scale Your Machine Learning with MLOps",
    newseventsvideo: "/videos/mlops.mp4",
  },
  {
    date: "November 17, 2022",
    img: webinarlogo,
    newsAndEventsText:
      "Webinar: Accelerate and Modernize Redshift Migration with AWS and Idexcel",
    newseventsvideo: "/videos/Redshift-Migration.mp4",
  },
  {
    date: "October 27, 2022",
    img: webinarlogo,
    newsAndEventsText:
      "Webinar: How to Accelerate Data Extraction for Public Sector Organizations",
    newseventsvideo:
      "/videos/How-to-Accelerate-Data-Extraction-for-Public-Sector-Organizations.mp4",
  },
  {
    date: "June 30, 2022",
    img: webinarlogo,
    newsAndEventsText:
      "AWS Immersion Day: How Amazon Rekognition Accelerates Digital Transformation for Financial Services",
    newseventsvideo: "/videos/AWS-immersion-day-Digital-Transformation.mp4",
  },
  {
    date: "November 18, 2021",
    img: webinarlogo,
    newsAndEventsText:
      "TechTalk: Natural Language Processing for Accelerated Lending",
    newseventsvideo: "/videos/TechTalk-NLP.mp4",
  },
];
